import { TRootState } from '../reducers';
import { IWidgetSessionState } from '../reducers/types';

export const selectWidgetSessionState = ({ widgetSession }: TRootState): IWidgetSessionState => widgetSession;

export const selectWidgetSession = ({
  widgetSession,
}: TRootState): IWidgetSessionState['session'] | undefined => {
  return widgetSession.session;
};

export const selectWidgetSessionId = ({ widgetSession }: TRootState): string | undefined => {
  return widgetSession.session?.sessionId;
};

export const selectIsSessionExpired = ({ widgetSession }: TRootState): boolean => {
  return widgetSession.isSessionExpired;
};
